module.exports = __webpack_public_path__ + "img/kaspro_bank.42babb55.webp";